import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Index from './views/Index';
import Upload from "./views/Upload"
import MyUploads from './views/MyUploads';
import Browse from './views/Browse';
import './css/styles.css'
import PublicAccessAuthModal from './components/auth/PublicAccessAuthModal';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <PublicAccessAuthModal>
            <Index />
          </PublicAccessAuthModal>
        } />
        <Route exact path="/my" element={
          <PublicAccessAuthModal>
            <MyUploads />
          </PublicAccessAuthModal>
        } />
        <Route exact path="/browse" element={
          <PublicAccessAuthModal>
            <Browse />
          </PublicAccessAuthModal>
        } />
        <Route path="/:uploadId" element={
          <PublicAccessAuthModal>
            <Upload />
          </PublicAccessAuthModal>
        } />

        {/* TODO: Create community upload page */}
        {/* TODO: Create login page */}
        {/* TODO: Dark mode */}
        {/* TODO: Create searching of uploads based on title, description, uploadId */}
        {/* TODO: Create admin panel: Set file size limit, ban IPs, ban users */}
        {/* TODO: Create admin controls: delete uploads from links, change expiry date, reset password, see files with password */}
        {/* <Route path="*" element={<Error404 />}></Route> */}
        {/* TODO: REMOVE ALL LOCALHOST FOR PRODUCTION */}
        {/* TODO: Allow changing of background */}
      </Routes>
    </Router>
  )
}

export default App
